import { render, staticRenderFns } from "./InternationalDidService.vue?vue&type=template&id=3049cebe&"
import script from "./InternationalDidService.vue?vue&type=script&lang=js&"
export * from "./InternationalDidService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports